import { drawerProfile } from "./drawer-profile";

export const drawers = {
	drawerProfile,
	editData: "Editar información",
	viewlinkedplaces: "Ver locales vinculados",
	drawerCouvert: {
		code: "SKU",
		couvertGeneralData: "Datos generales de cover",
		taxGroup: "Grupo fiscal",
		taxProfile: "Perfil fiscal",
	},
	drawerGroup: {
		excludeTaxGroup: "Eliminar grupo",
		titles: {
			generalData: "Datos generales",
			vat: "IVA",
			service: "Servicio",
		},
		fiscalProductGroupType: {
			vat: "IVA Portugal",
			vatFactura: "IVA México",
			vatSpain: "IVA España",
			service: "Servicio",
			serviceNational: "Servicio Nacional",
			invoice: "Factura",
		},
		fields: {
			taxRate: {
				label: "Alícuota (%)",
			},
			code: {
				label: "SKU",
			},
			productType: {
				label: "Tipo de producto",
			},
			taxExemption: {
				label: "Exención de impuesto",
			},
			taxType: {
				label: "Tipo de impuesto",
			},
		},
	},
};
